import { useTranslation } from "react-i18next"

import Table from "../../../../Components/Table"
import EmptyLookups from "../EmptyStates/EmptyLookups"
import { getColumns } from "./columns"

// §BLOCK 4 — Lookup activity table.
// 6 sortable columns; pagination 20/page; default sort Date desc.
const ReceiptLookupTable = ({
  loading,
  data,
  totalCount,
  page,
  pageSize,
  columns,
  onChangeOrdering,
  onChangePage
}) => {
  const { t } = useTranslation()
  const columnMap = getColumns({ t })

  const activeCols = (columns || [])
    .filter((c) => c.active !== false)
    .map((c) => columnMap[c.field_id])
    .filter(Boolean)

  const handleChange = (_pagination, _filters, sorter, extra) => {
    if (extra?.action !== "sort") return
    const field = sorter?.field
    if (!field || !sorter?.order) {
      onChangeOrdering(null)
      return
    }
    onChangeOrdering(sorter.order === "ascend" ? field : `-${field}`)
  }

  return (
    <Table
      loading={loading}
      dataSource={data || []}
      columns={activeCols}
      rowKey="id"
      onChange={handleChange}
      EmptyComponent={EmptyLookups}
      pagination={{
        current: page,
        pageSize,
        total: totalCount,
        onChange: onChangePage
      }}
      scroll={{ x: 900 }}
      onRow={(record) => ({ "data-testid": `deflect-user-lookup-row-${record.id}` })}
    />
  )
}

export default ReceiptLookupTable
